<template>
  <div v-if="content && event">
    <div class="max-w-6xl mx-auto text-3xl">
      <div class="text-sm text-center uppercase mono">
        {{ event.parent }} → {{ event.parent_event }}
      </div>
      <h1 class="mt-12 mb-3 text-center mono">{{ event.title }}</h1>
      <div class="dates text-center mb-12 text-sm uppercase mono">
        {{ event.date }}.2021, {{ event.start }} → {{ event.end }} CEST
      </div>

      <ul
        v-if="event.people.length"
        class="text-lg mt-6 hidden md:block text-center my-12 space-x-3 mono"
      >
        <li
          v-for="(person, idx) in sortBy(event.people, ['sort'])"
          :key="idx"
          class="border-white border inline-block rounded hover:bg-white"
        >
          <router-link :to="`/${person.uri}`" class="px-3 py-1">{{
            person.title
          }}</router-link>
        </li>
      </ul>

      <div
        v-if="content.image"
        v-html="content.image"
        class="my-12 flex justify-center"
      ></div>
      <div class="mx-6" v-html="event.description" />

      <div v-if="allowCookies && event.video" class="mt-12">
        <vue-plyr :options="videoOptions" ref="plyr">
          <div
            :data-plyr-provider="event.video_type || 'youtube'"
            :data-plyr-embed-id="event.video"
          ></div>
        </vue-plyr>
        <div class="text-base mt-6 text-center mono">
          <a :href="`https://youtube.com/v/${event.video}`" target="_blank"
            >For closed captions, you may view the video directly on YouTube
            ↗</a
          >
        </div>
      </div>
      <div v-else class="mx-6">
        <div
          class="
            mt-12
            w-full
            md:h-72
            h-48
            md:py-72
            flex
            items-center
            justify-center
            border border-white
            text-center
          "
        >
          <div
            @click="acceptCookies"
            class="
              rounded-full
              md:border
              border-white
              text-base
              md:text-xl
              py-2
              px-12
              mono
              cursor-pointer
              md:hover:bg-white
              md:hover:text-black
            "
          >
            Click to allow loading of YouTube videos/cookies
          </div>
        </div>

        <div class="text-sm mt-6 text-center mono">
          <a :href="`https://youtube.com/v/${event.video}`" target="_blank"
            >Alternatively, you may view the video directly on YouTube ↗</a
          >
        </div>
      </div>

      <div v-if="event.files.length" class="my-12">
        <h3 class="my-2">Attachments</h3>
        <ul>
          <li
            v-for="file in event.files"
            :key="file.url"
            class="border-t border-white"
          >
            <a :href="file.url" target="_blank" class="block my-2"
              >→ {{ file.title || file.filename }}</a
            >
          </li>
        </ul>
      </div>
    </div>

    <Separator
      pattern="oval"
      class="mt-48 w-full h-20 border-t border-white border-b"
    />
    <Separator
      pattern="crest"
      class="mt-3 w-full h-16 border-t border-white border-b"
    />
    <Separator pattern="brick" class="mt-3 w-full h-32 border-t border-white" />
  </div>
</template>

<script>
import { sortBy } from "lodash"
import Separator from "@/components/Separator.vue"
export default {
  name: "Event",
  props: ["content"],
  data() {
    return {
      allowCookies: false,
      videoOptions: {
        muted: false,
        autoplay: false,
        playsinline: true,
      },
    }
  },
  components: {
    Separator,
  },
  computed: {
    events() {
      return this.content.projects
        .map((project) => project.items.map((item) => item.events).flat())
        .flat()
    },
    event() {
      return this.events.find((e) => e.link === this.$route.path)
    },
  },
  mounted() {
    window.scrollTo(0, 0)

    if (this.$cookies.isKey("YCAAllowCookies")) {
      if (this.$cookies.get("YCAAllowCookies") === "true") {
        this.allowCookies = true
      }
    }
  },
  watch: {
    $route() {
      window.scrollTo(0, 0)
    },
    allowCookies() {
      if (this.allowCookies) {
        this.$nextTick(() => {
          this.$refs.plyr.player.on("play", () => {
            this.$gtag.event(this.event.title, {
              event_category: "video",
              event_label: "play",
            })
          })
          this.$refs.plyr.player.on("playing", () => {
            this.$gtag.event(this.event.title, {
              event_category: "video",
              event_label: "playing",
            })
          })
          this.$refs.plyr.player.on("pause", () => {
            this.$gtag.event(this.event.title, {
              event_category: "video",
              event_label: "pause",
            })
          })
        })
      }
    },
  },
  methods: {
    sortBy,
    acceptCookies() {
      this.$cookies.set("YCAAllowCookies", true, "14d")
      this.allowCookies = true
    },
  },
}
</script>
